import React from 'react'
import { primary } from '@/constant'
import { Stack } from '@mui/material'
import Text from '@/components/Text'
import Button from '@/components/Button'

export interface InfoCardProps {
  onClick: () => void;
}

const InfoCard: React.FC<InfoCardProps> = (props) => {
  const { onClick } = props
  return (
    <>
      <Stack sx={{ margin: '0 5%', flex: '1' }}>
        <Text>账号密码</Text>
        <Text size="xs" weight="thin" sx={{ display: 'flex', gap: '4px' }}>
          密码规则限制在
          <Text size="xs" weight="thin" sx={{ color: primary }}>
            8-10
          </Text>
          <Text size="xs" weight="thin">
            位之间
          </Text>
        </Text>
      </Stack>
      <Button
        type="primary"
        sx={{ height: 40, width: 120, margin: '0 15%' }}
        onClick={onClick}
      >
        修改
      </Button>
    </>
  )
}

export default InfoCard
